import { useState, useEffect, type RefObject } from 'react';

const COMPACT_BREAKPOINT = 480;

/**
 * Tracks a container element's size via ResizeObserver.
 * Returns `compact: true` when width < 480px.
 */
export function useContainerSize(ref: RefObject<HTMLElement | null>) {
  const [size, setSize] = useState({ width: 0, height: 0, compact: true });

  useEffect(() => {
    const el = ref.current;
    if (!el) return;

    const observer = new ResizeObserver(([entry]) => {
      const { width, height } = entry.contentRect;
      setSize({ width, height, compact: width < COMPACT_BREAKPOINT });
    });

    observer.observe(el);
    return () => observer.disconnect();
  }, [ref]);

  return size;
}
